import { ICallerInfo } from './caller-info';
import { ILogCallJobInfo } from './log-call-job-info';

export enum TelephonyEventEnum {
  LogCall = 7,
  CallLogged = 8, // call logged successfully
}

export interface ITelephonyEvent {
  eventType: TelephonyEventEnum;
  number?: string; // number being called or calling in
  caller?: ICallerInfo;
  direction?: string;

  // for logging a job against a call
  telephonyJobInfo?: ILogCallJobInfo;

  fromDeployment?: boolean; // true if logging a call from deployment screen
}
